import _isEmpty from 'lodash/isEmpty';
import _cloneDeep from 'lodash/cloneDeep';
import {
  useDataModel
} from '@thd-nucleus/data-sources';
import { useStore } from '@thd-nucleus/experience-context';
import { isFulfillable } from '@thd-olt-component-react/fulfillment/dist/pod/helpers/pod-fulfillment-utils';
import { EMPTY_OBJECT } from '../../../../utils/empty-reference';
import { selectProductColor, selectCabinetProductDimensions,
  selectFillerProductDimensions } from '../../../../store/cabinetVisualizer/selectors';

export const useSuperSkuItem = (itemId, modalType) => {
  const store = useStore();
  const { storeId = '121' } = store;
  const { data: productData } = useDataModel('product', {
    variables: { itemId, storeId },
    ssr: true,
    skip: !itemId
  });

  const product = productData?.product || EMPTY_OBJECT;
  let dimensions = EMPTY_OBJECT;
  if (modalType && ['Filler'].includes(modalType[0])) {
    dimensions = selectFillerProductDimensions(product);
  } else {
    dimensions = selectCabinetProductDimensions(product);
  }

  const productIsInStock = isFulfillable(product);

  return {
    itemId,
    selectedColor: selectProductColor(product),
    selectedHeight: dimensions.height,
    selectedWidth: dimensions.width,
    selectedDepthNumber: parseFloat(dimensions.depth.replace(' in', '')),
    selectedWidthNumber: parseFloat(dimensions.width.replace(' in', '')),
    selectedHeightNumber: parseFloat(dimensions.height.replace(' in', '')),
    product,
    productIsInStock
  };
};
